"use client";

export interface CadastroProfile {
  id: string;
  nome: string;
  sobrenome: string;
  email: string;
  celular: string;
  dataNascimento: string;
  state: string;
}

const CADASTRO_PROFILE_STORAGE_KEY = "cazeprofile";
export const CADASTRO_SESSION_EVENT = "cadastro-session-change";

function dispatchCadastroSessionEvent() {
  if (typeof window === "undefined") return;

  window.dispatchEvent(new CustomEvent(CADASTRO_SESSION_EVENT));
}

export function saveCadastroProfile(profile: CadastroProfile) {
  if (typeof window === "undefined") return;

  const fullName = [profile.nome, profile.sobrenome]
    .map((value) => value.trim())
    .filter(Boolean)
    .join(" ");

  window.localStorage.setItem("cazeemail", profile.email);
  window.localStorage.setItem("cazename", fullName || profile.nome.trim());
  window.localStorage.setItem(
    CADASTRO_PROFILE_STORAGE_KEY,
    JSON.stringify(profile),
  );
  dispatchCadastroSessionEvent();
}

export function loadCadastroProfile() {
  if (typeof window === "undefined") return null;

  const rawValue = window.localStorage.getItem(CADASTRO_PROFILE_STORAGE_KEY);

  if (!rawValue) return null;

  try {
    return JSON.parse(rawValue) as CadastroProfile;
  } catch {
    return null;
  }
}

export function clearCadastroProfile() {
  if (typeof window === "undefined") return;

  window.localStorage.removeItem("cazeemail");
  window.localStorage.removeItem("cazename");
  window.localStorage.removeItem(CADASTRO_PROFILE_STORAGE_KEY);
  dispatchCadastroSessionEvent();
}

export function hasCadastroSession() {
  if (typeof window === "undefined") return false;

  return Boolean(window.localStorage.getItem("cazeemail"));
}
